import './ProjectShowcase.css'

function ShowcaseDesc({children, Title = 'Unnamed Project', Date = 'Today', ButtonURL='', ButtonText="Play"}) {
    return(
        <>
            <h1>{Title}</h1>
            <p>{Date}</p>
            <p className='desc'>{children}</p>
            {(ButtonURL.length > 0) ? (<a href={ButtonURL}><button>{ButtonText}</button></a>) : (<></>)}
        </>
    );
}

export default ShowcaseDesc;